import $ from 'jquery';

export default class CatFilter {
    constructor() {
        $('.js-news__cat-filter-toggle').on('click', function() {
            const $this = $(this);

            $this.toggleClass('is-active');

            $this.next().slideToggle();
        });
    };
};
